module.exports = __webpack_public_path__ + "img/Dantam Hair 23.2ee274b1.jpg";